import {useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {CaptacionService} from "abastecemento/service";
import {captacion_view_adapter} from "abastecemento/model";
import {EntityCreatePage} from "base/entity";
import {CaptacionForm} from "../presentational/form";

const CreateCaptacionPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const basePath = location.pathname.split("/new")[0];
    const {codigo} = useParams();
    const codigoConcello = codigo;

    const [error, setError] = useState("");

    const handleFormSubmit = captacion => {
        CaptacionService.create(captacion_view_adapter({...captacion}))
            .then(createdCaptacion => {
                navigate(`${basePath}/${createdCaptacion.id}/summary`);
            })
            .catch(error => {
                setError(error);
            });
    };

    const handleFormCancel = () => {
        navigate(basePath);
    };

    return (
        <EntityCreatePage
            form={
                <CaptacionForm
                    onSubmit={handleFormSubmit}
                    onCancel={handleFormCancel}
                    concello={codigoConcello}
                />
            }
            title="Rexistro de Captación"
            error={error}
        />
    );
};

export default CreateCaptacionPage;
